export const CANVA_HELP_STRING_KEYS = {
  fabAria: 'app-canva-help-fab-aria-label',
  modalTitle: 'app-canva-help-modal-title',
  videoTitle: 'app-canva-help-video-title',
  contactPrefix: 'app-canva-help-contact-prefix',
} as const;

export const CANVA_HELP_DEFAULTS: Record<string, string> = {
  [CANVA_HELP_STRING_KEYS.fabAria]: 'Help and tutorial',
  [CANVA_HELP_STRING_KEYS.modalTitle]: 'Help',
  [CANVA_HELP_STRING_KEYS.videoTitle]: 'Muzaic tutorial',
  [CANVA_HELP_STRING_KEYS.contactPrefix]: 'Questions? Contact us at',
};
